import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {InputTextModule} from 'primeng/inputtext';
import {ButtonModule} from 'primeng/button';
import {Router, RouterModule} from '@angular/router';
import {SelectModule} from 'primeng/select';
import {TextareaModule} from 'primeng/textarea';
import {TranslationPipe} from '../../../pipes/translation.pipe';
import {CreateCustomerRequestDto, CustomerClient, TenantClient} from '../../../api/api-client';
import {FeedbackDataService} from '../../../services/feedback-data.service';
import {Editor} from 'primeng/editor';
import {isFormControlInvalid} from '../../../util/form-control-invalid-checker';
import {twoFieldsOrValidator} from '../../../validators/two-fields-or.validator';
import {SubscriptionManager} from '../../../services/subscription-manager.service';


@Component({
  selector: 'app-create-customer',
  imports: [ReactiveFormsModule, RouterModule, InputTextModule, TextareaModule, SelectModule, ButtonModule, RouterModule, TranslationPipe, Editor],
  providers: [SubscriptionManager],
  templateUrl: './create-customer.component.html',
  styleUrl: './create-customer.component.scss'
})
export class CreateCustomerComponent implements OnInit {

  createCustomerForm = new FormGroup({
    firstName: new FormControl('', Validators.required),
    lastName: new FormControl('', Validators.required),
    company: new FormControl(''),
    eMail: new FormControl(''),
    phoneNumber: new FormControl(''),
    country: new FormControl('', [Validators.required]),
    street: new FormControl(''),
    houseNumber: new FormControl('', Validators.pattern('\\d+\\w*')),
    postalCode: new FormControl('', [Validators.required, Validators.pattern('[0-9]{4,5}')]),
    city: new FormControl('', [Validators.required]),
    notes: new FormControl(''),
  });

  countries: string[] = ["Österreich", "Deutschland"]
  submitButtonClicked:boolean=false;

  constructor(
    private readonly subscriptionManager:SubscriptionManager,
    private readonly tenantService: TenantClient,
    private readonly customerService: CustomerClient,
    private readonly router: Router,
    private readonly feedbackService: FeedbackDataService
  ) {
  }

  ngOnInit(): void {
    this.subscriptionManager.call(
    this.tenantService.getCountryForTenant(),
      (x => {
      this.createCustomerForm.setValue({
        firstName: "",
        lastName: "",
        company: "",
        eMail: "",
        phoneNumber: "",
        street: "",
        houseNumber: "",
        postalCode: "",
        city: "",
        notes: "",
        country: x.result
      })
    })
    );
    this.feedbackService.feedbackData=null;

    this.createCustomerForm.get("phoneNumber")?.setValidators([twoFieldsOrValidator(this.createCustomerForm,"eMail"), Validators.pattern('[- +()0-9]{6,}')])
    this.createCustomerForm.get("eMail")?.setValidators([twoFieldsOrValidator(this.createCustomerForm,"phoneNumber"),Validators.email])

    // Trigger validation when phoneNumber changes
    // emitEvent=false, because else endless loop between phoneNumber and eMail validators
    this.subscriptionManager.call(
    this.createCustomerForm.get("phoneNumber")?.valueChanges,
      (() => {
      this.createCustomerForm.get("eMail")?.updateValueAndValidity({ emitEvent: false });
    })
    );
    // Trigger validation when eMail changes
    this.subscriptionManager.call(
    this.createCustomerForm.get("eMail")?.valueChanges,
      (() => {
      this.createCustomerForm.get("phoneNumber")?.updateValueAndValidity({ emitEvent: false });
    })
    );
  }

  onSubmit(openCreatePetPage: boolean) {
    this.submitButtonClicked = true;
    if (this.createCustomerForm.valid) {
      this.subscriptionManager.call(
      this.customerService.createCustomer(
        <CreateCustomerRequestDto>{
            firstName: this.createCustomerForm.value.firstName ?? "",
            lastName: this.createCustomerForm.value.lastName ?? "",
            company: this.createCustomerForm.value.company ?? "",
            eMail: this.createCustomerForm.value.eMail ?? "",
            phoneNumber: this.createCustomerForm.value.phoneNumber ?? "",
            street: this.createCustomerForm.value.street ?? "",
            houseNumber: this.createCustomerForm.value.houseNumber ?? "",
            postalCode: this.createCustomerForm.value.postalCode ?? "",
            city: this.createCustomerForm.value.city ?? "",
            country: this.createCustomerForm.value.country ?? "",
            notes: this.createCustomerForm.value.notes ?? "",
        }),
        (x => {
        if (openCreatePetPage) {
          this.router.navigate(['../loggedin/pets/create'], {queryParams: {customerId: x.result}});
        } else {
          this.router.navigate(['../loggedin/customer-detail/' + x.result],)
        }
      })
      );
    }
  }


  protected readonly isFormControlInvalid = isFormControlInvalid;
}
